module.exports = "/images/close-popup-btn.svg?b8d05766a49eadcedcc4dcbb5b512cbe";